<form *ngIf="form">
  <div class="ps-large-y">
    <h2>
      {{
        (addressType === FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS
          ? 'MMB.apis.form.destination.title'
          : 'MMB.apis.form.home.title'
        ) | finLocalization
      }}
      <ng-container *ngIf="countryName$ | async as countryName">
        <span *ngIf="countryName">{{ ' ' + countryName }}</span>
      </ng-container>
    </h2>

    <fcom-notification
      *ngIf="addressType === FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS"
      class="ps-medium-t"
      [theme]="NotificationTheme.INFO"
    >
      {{ 'MMB.apis.form.destination.notification' | finLocalization }}
    </fcom-notification>
  </div>

  <div class="ps-small-b font-body-1 nordic-blue-900-text align-right">
    {{ 'MMB.apis.form.passport.mandatoryFields' | finLocalization }}
  </div>

  <div class="flex flex--wrap">
    <ng-container *ngIf="(countryRegions$ | async)?.length > 0; else stateInput">
      <fin-select-input
        data-testid="form-field-state"
        class="flex-1 input-field"
        [controlName]="'state'"
        [translationPrefix]="
          addressType === FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS
            ? 'MMB.apis.form.destination.state'
            : 'MMB.apis.form.home.state'
        "
        [parentForm]="form"
        [options]="countryRegions$ | async"
        [displayMargin]="false"
      >
      </fin-select-input>
    </ng-container>

    <ng-template #stateInput>
      <fcom-text-input
        data-testid="form-field-input-state"
        class="flex-1 input-field"
        [translationPrefix]="
          addressType === FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS
            ? 'MMB.apis.form.destination.state'
            : 'MMB.apis.form.home.state'
        "
        [parentForm]="form"
        [controlName]="'state'"
        [displayMargin]="false"
      >
      </fcom-text-input>
    </ng-template>

    <fcom-text-input
      data-testid="form-field-zipCode"
      class="flex-1 input-field"
      [translationPrefix]="
        addressType === FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS
          ? 'MMB.apis.form.destination.zipCode'
          : 'MMB.apis.form.home.zipCode'
      "
      [parentForm]="form"
      [controlName]="'zipCode'"
      [displayMargin]="false"
    >
    </fcom-text-input>
  </div>

  <div class="flex flex--wrap ps-large-b">
    <fcom-text-input
      data-testid="form-field-destinationCity"
      class="flex-1 flex--basis0"
      [translationPrefix]="
        addressType === FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS
          ? 'MMB.apis.form.destination.city'
          : 'MMB.apis.form.home.city'
      "
      [parentForm]="form"
      [controlName]="'city'"
      [displayMargin]="false"
    >
    </fcom-text-input>

    <fcom-text-input
      data-testid="form-field-address"
      class="flex-2 flex--basis0"
      [translationPrefix]="
        addressType === FinnairApisRequirementKeyEnum.DESTINATION_ADDRESS
          ? 'MMB.apis.form.destination.address'
          : 'MMB.apis.form.home.address'
      "
      [parentForm]="form"
      [controlName]="'address'"
      [displayMargin]="false"
    >
    </fcom-text-input>
  </div>

  <div role="presentation" class="border-top-dashed nordic-blue-100-border fill"></div>

  <div class="ps-large-y flex flex--end">
    <fcom-button
      [type]="ButtonType.SUBMIT"
      [loading]="loading"
      (clickBtn)="saveAndContinue()"
      [text]="'MMB.apis.form.buttons.confirmSave' | finLocalization"
    ></fcom-button>
  </div>
</form>
